import { Box, BoxProps, ColorOptions, Spacer, TextInputNewProps, TextNew } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { isEmptyObject } from '@jfs/utils'
import * as React from 'react'
import { useEffect, useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { Dropdown } from '../../components/Dropdown'
import { FileSelector } from '../../components/FileSelector'
import { List } from '../../components/List'
import { useLazyApiData, useStores } from '../../data/store'
import { MessageTypes, clean, isAccessible } from '../../utils'
import SearchButton from './SearchButton'

const FormBox = ({ children }: any) => {
  return <Box {...styles.formContainer}>{children}</Box>
}

const EMSDevices = () => {
  const columns = ['mid', 'deviceId']
  const storesColumns = ['mid', 'storeCode', 'institutionId']
  const institutesColumns = ['institutionId', 'name']

  const [filename, setFilename] = useState('')
  const [storeFilename, setStoreFilename] = useState('')
  const [instituteFilename, setInstituteFilename] = useState('')
  const [mids, setMids] = React.useState<any>([])
  const [mid, setMid] = useState('')
  const [inputKeys, setInputkeys] = useState<String[]>([])
  const [selectedSearchType, setSelectedSerachType] = useState(SEARCH_DEVICE_BY[0].id)
  const [searchText, setSearchText] = useState('')

  const [institutions, setInstitutions] = React.useState<any>([])
  const [stores, setStores] = React.useState<any>([])

  const [isLoading, setLoading] = useState(false)
  const {
    deviceMappings,
    searchDevices,
    delink,
    accessConfig,
    bulkLinkDevice,
    setMessage,
    sampleFileDownload,
    onboardStores,
    onboardInstitutes,
  } = useStores((store) => ({
    getAll: store.devices.getAllMappings,
    searchDevices: store.devices.searchEMSDevices,
    deviceMappings: store.devices.getEMSDeviceMappings(),
    delink: store.devices.delinkEMSDevice,
    bulkLinkDevice: store.devices.bulkEMSLinkDevice,
    setMessage: store.message.setMessage,
    accessConfig: store.user.getAccessConfig(['merchant_config', 'device_mapping']),
    sampleFileDownload: store.sampleFileDownload,
    onboardStores: store.devices.bulkEMSStoresOnboard,
    onboardInstitutes: store.devices.bulkEMSInstitutesOnboard,
  }))
  const [lazySearchApi, lazySearchHandler] = useLazyApiData(searchDevices)
  const [lazyDelinkApi, { state }] = useLazyApiData(delink)
  const [lazyLinkApi, linkApiHandler] = useLazyApiData(bulkLinkDevice)

  const [lazyOnboardStoresApi, onboardStoresHandler] = useLazyApiData(onboardStores)
  const [lazyOnboardInstitutesApi, onboardInstituteHandler] = useLazyApiData(onboardInstitutes)
  const [loadingIndex, setLoadingIndex] = useState(-1)

  useEffect(() => {
    if (linkApiHandler?.state === 'fulfilled' && mids.length > 0) {
      const respData = linkApiHandler?.data
      let transformedData = respData.map((item: any) => [item.status, item.message, item.code])
      transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])
      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const data: any = []
        data.push([...inputKeys, ...transformedData[0]])
        mids.map((item: any, index: number) => {
          data.push([...Object.values(item), ...transformedData[index + 1]])
        })
        setMids([])

        workbook.sheet(0)?.cell('A1').value(data)

        const blob = await workbook.outputAsync({
          type: 'blob',
        })
        var url = window.URL.createObjectURL(blob as Blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `linkDeviceResult_${filename.split('.').slice(0, -1).join('.')}.xlsx`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkApiHandler?.state])

  useEffect(() => {
    if (onboardStoresHandler?.state === 'fulfilled' && stores.length > 0) {
      const respData = onboardStoresHandler?.data
      let transformedData = respData.map((item: any) => [item.status, item.message, item.code])
      transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])

      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const data: any = []
        data.push([...inputKeys, ...transformedData[0]])

        stores.map((item: any, index: number) => {
          data.push([...Object.values(item), ...transformedData[index + 1]])
        })
        setStores([])

        workbook.sheet(0)?.cell('A1').value(data)

        const blob = await workbook.outputAsync({
          type: 'blob',
        })
        var url = window.URL.createObjectURL(blob as Blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `onboardStoresResult_${storeFilename.split('.').slice(0, -1).join('.')}.xlsx`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onboardStoresHandler?.state])

  useEffect(() => {
    if (onboardInstituteHandler?.state === 'fulfilled' && institutions.length > 0) {
      const respData = onboardInstituteHandler?.data
      let transformedData = respData.map((item: any) => [item.status, item.message, item.code])
      transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])
      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const data: any = []
        data.push([...inputKeys, ...transformedData[0]])
        institutions.map((item: any, index: number) => {
          data.push([...Object.values(item), ...transformedData[index + 1]])
        })
        setInstitutions([])

        workbook.sheet(0)?.cell('A1').value(data)

        const blob = await workbook.outputAsync({
          type: 'blob',
        })
        var url = window.URL.createObjectURL(blob as Blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `onboardInstitutesResult_${instituteFilename.split('.').slice(0, -1).join('.')}.xlsx`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onboardInstituteHandler?.state])

  useEffect(() => {
    if (lazySearchHandler.state === 'pending') {
      setLoading(true)
    } else {
      setLoading(false)
    }
  }, [lazySearchHandler.state])
  const keyExtractor = (item: any): string => {
    return item.id
  }
  const headTitles = [{ mid: 'MID' }, { tid: 'TID' }, { dsn: 'DSN' }, { status: 'Status' }, { mapping: 'Actions' }]
  const headTitlesWithoutAction = [{ mid: 'MID' }, { tid: 'TID' }, { dsn: 'DSN' }, { status: 'Status' }]
  const onSearch = (data: any) => {
    const req = clean(data)
    lazySearchApi(req)
  }

  const handleDelink = (data: any, index: number) => {
    setLoadingIndex(index)
    lazyDelinkApi(data?.dsn)
  }

  const onSearchTypeChanged = (searchTypeObj) => {
    setSelectedSerachType(searchTypeObj.id)
  }
  const isUnlinkAccesible = isAccessible(accessConfig, 'unlink')
  const isLinkAllowed = isAccessible(accessConfig, 'create')
  const renderList = () => {
    if (isLoading) {
      return (
        <TextNew
          textAlign={'center'}
          title={'Loading...'}
          color={'BLACK_21'}
          fontFamily={'jiotype-bold'}
          fontSize={16}
        />
      )
    } else if (deviceMappings.length < 1) {
      return (
        <TextNew type={'body16'} textAlign="center">
          {'No Devices found'}
        </TextNew>
      )
    }
    return (
      <List
        keyExtractor={keyExtractor}
        headTitle={isUnlinkAccesible ? headTitles : headTitlesWithoutAction}
        numOfColumns={isUnlinkAccesible ? 5 : 4}
        sizeConfig={isUnlinkAccesible ? [1, 0.8, 1.2, 0.8, 1] : [1, 1, 1, 1]}
        data={deviceMappings}
        listTitle={'Physical Merchant - Device Mapping List'}
        onPress={handleDelink}
        isActionLoading={state === 'pending'}
        loadingIndex={loadingIndex}
        cellTextStyle={{ fontSize: 12, fontFamily: 'jiotype-medium' }}
        headerTextStyle={{ fontSize: 12, fontFamily: 'jioType-bold', textTransform: 'capitalize' }}
      />
    )
  }

  const onSubmitClicked = () => {
    const data = { [selectedSearchType]: searchText }
    onSearch({ ...data })
  }

  const isValidEntry = (obj: any) => {
    return !isEmptyObject(obj)
  }

  const isValidStoreEntry = (obj: any) => {
    return !isEmptyObject(obj) && !!obj?.storeCode && !!obj?.institutionId
  }
  const isValidInstituteEntry = (obj: any) => {
    return !isEmptyObject(obj) && !!obj?.name && !!obj?.institutionId
  }
  const readExcel = async (file: any) => {
    if (!file) {
      setFilename('')
      setMids([])
      setInputkeys([])
      return
    }
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          setFilename(file.name)
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                obj[key] = `${String(row._cells[i]?.value() ?? '')?.trim()}`
              }
            }
            isValidEntry(obj) && values.push(obj)
          })
          const isExcelInvalid = columns.some((item) => !keys.includes(item))
          if (!isExcelInvalid) {
            setMids(values)
            setInputkeys(keys)
            resolve(values)
          } else {
            setFilename('')
            setMids([])
            setInputkeys([])
            reject('Invalid File')
          }
        })
        .catch(() => {
          setFilename('')
          setMids([])
          setInputkeys([])
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setFilename('')
      setMessage(e, MessageTypes.ERROR)
    }
    setLoading(false)
  }

  const readStoresOnboardExcel = async (file: any) => {
    if (!file) {
      setStoreFilename('')
      setStores([])
      setInputkeys([])
      return
    }
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          setStoreFilename(file.name)
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                obj[key] = `${String(row._cells[i]?.value() ?? '')?.trim()}`
              }
            }
            isValidStoreEntry(obj) && values.push(obj)
          })
          const isExcelInvalid = storesColumns.some((item) => !keys.includes(item))
          if (!isExcelInvalid) {
            setStores(values)
            console.log('Stores: ', values)
            setInputkeys(keys)
            resolve(values)
          } else {
            setStoreFilename('')
            setStores([])
            setInputkeys([])
            reject('Invalid File')
          }
        })
        .catch(() => {
          setStoreFilename('')
          setStores([])
          setInputkeys([])
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setStoreFilename('')
      setMessage(e, MessageTypes.ERROR)
    }
    setLoading(false)
  }

  const readInstitutesOnboardExcel = async (file: any) => {
    if (!file) {
      setInstituteFilename('')
      setInstitutions([])
      setInputkeys([])
      return
    }
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          setInstituteFilename(file.name)
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                obj[key] = `${String(row._cells[i]?.value() ?? '')?.trim()}`
              }
            }
            isValidInstituteEntry(obj) && values.push(obj)
          })
          const isExcelInvalid = institutesColumns.some((item) => !keys.includes(item))
          if (!isExcelInvalid) {
            setInstitutions(values)
            console.log('Institutions: ', values)
            setInputkeys(keys)
            resolve(values)
          } else {
            setInstituteFilename('')
            setInstitutions([])
            setInputkeys([])
            reject('Invalid File')
          }
        })
        .catch(() => {
          setInstituteFilename('')
          setInstitutions([])
          setInputkeys([])
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setInstituteFilename('')
      setMessage(e, MessageTypes.ERROR)
    }
    setLoading(false)
  }

  return (
    <Box flex={1}>
      <TextNew title={'Devices Mapping'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />

      <Spacer direction="vertical" size={24} />
      {isLinkAllowed && (
        <Box borderWidth={1} pl={24} pb={24} bg={'WHITE'} borderRadius={6} pt={16} w={'50%'}>
          <TextNew title={'Link Devices'} fontSize={14} fontWeight={'500'} color={'BLACK_21'} />
          <Spacer direction="vertical" size={4} />
          <Box flexDirection={'row'} align={'flex-end'} justify={'space-between'}>
            <FileSelector
              onPress={() => lazyLinkApi(mids)}
              isLoading={linkApiHandler?.state === 'pending'}
              readFile={readExcel}
              fileType={'.xlsx'}
              isValidFile={mids.length > 0}
            />
            {mids.length === 0 && (
              <ButtonNew
                title={'Sample file'}
                type="tertiary"
                onPress={() => {
                  sampleFileDownload('Sample_device_link_file')
                }}
              />
            )}
          </Box>
        </Box>
      )}
      {isLinkAllowed && (
        <Box borderWidth={1} pl={24} pb={24} bg={'WHITE'} borderRadius={6} pt={16} w={'50%'} marginTop={16}>
          <TextNew title={'Onboard Institutes'} fontSize={14} fontWeight={'500'} color={'BLACK_21'} />
          <Spacer direction="vertical" size={4} />
          <Box flexDirection={'row'} align={'flex-end'} justify={'space-between'}>
            <FileSelector
              onPress={() => lazyOnboardInstitutesApi(institutions)}
              isLoading={onboardInstituteHandler?.state === 'pending'}
              readFile={readInstitutesOnboardExcel}
              fileType={'.xlsx'}
              isValidFile={institutions.length > 0}
            />
            {institutions.length === 0 && (
              <ButtonNew
                title={'Sample file'}
                type="tertiary"
                onPress={() => {
                  sampleFileDownload('Sample_Onboard_Institute_file')
                }}
              />
            )}
          </Box>
        </Box>
      )}
      {isLinkAllowed && (
        <Box borderWidth={1} pl={24} pb={24} bg={'WHITE'} borderRadius={6} pt={16} w={'50%'} marginTop={16}>
          <TextNew title={'Onboard Stores'} fontSize={14} fontWeight={'500'} color={'BLACK_21'} />
          <Spacer direction="vertical" size={4} />
          <Box flexDirection={'row'} align={'flex-end'} justify={'space-between'}>
            <FileSelector
              onPress={() => lazyOnboardStoresApi(stores)}
              isLoading={onboardStoresHandler?.state === 'pending'}
              readFile={readStoresOnboardExcel}
              fileType={'.xlsx'}
              isValidFile={stores.length > 0}
            />
            {stores.length === 0 && (
              <ButtonNew
                title={'Sample file'}
                type="tertiary"
                onPress={() => {
                  sampleFileDownload('Sample_Onboard_Store_file')
                }}
              />
            )}
          </Box>
        </Box>
      )}
      <Spacer direction="vertical" size={24} />
      <Box flexDirection={'row'}>
        <Dropdown
          data={SEARCH_DEVICE_BY}
          title={SEARCH_DEVICE_BY[0].value}
          passFullItemOnSelection
          minWidth={250}
          selectedData={onSearchTypeChanged}
        />
        <Spacer direction={'horizontal'} size={8} />
        <TextInputNew value={searchText} onChangeText={setSearchText} {...styles.textinputStyle} />
        <Spacer direction={'horizontal'} size={8} />
        <SearchButton onProceedPress={onSubmitClicked} disabled={!searchText} />
      </Box>
      <Spacer direction="vertical" size={24} />
      {renderList()}
    </Box>
  )
}

export default EMSDevices
const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    pv: 16,
  } as BoxProps,
  textinputStyle: {
    type: 'bodySecondary14',
    borderColor: '#d1d3e2' as ColorOptions,
    labelPaddingBottom: 8,
    borderRadius: 4,
    fontFamily: 'jiotype-medium',
    labelColor: '#757575' as ColorOptions,
    labelFontSize: 12,
    fontSize: 12,
    selectionColor: 'BLUE',
    paddingHorizontal: 8,
    height: 36,
    color: '#212121' as ColorOptions,
    borderWidth: 1,
  } as TextInputNewProps,
}
const DEVICE_TYPES = [
  { id: 1, value: 'POS' },
  { id: 2, value: 'VOICEBOX' },
]

const SEARCH_DEVICE_BY = [
  { id: 'entityId', value: 'Entity Id' },
  { id: 'deviceSerialNumber', value: 'Device Serial Number' },
  { id: 'tid', value: 'TID' },
]
